/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsDevice,
    MelcoModelsDeviceFromJSON,
    MelcoModelsDeviceFromJSONTyped,
    MelcoModelsDeviceToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsApiKeyAuth
 */
export interface MelcoModelsApiKeyAuth {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsApiKeyAuth
     */
    api_key: string;
    /**
     * 
     * @type {MelcoModelsDevice}
     * @memberof MelcoModelsApiKeyAuth
     */
    device_info: MelcoModelsDevice;
}

export function MelcoModelsApiKeyAuthFromJSON(json: any): MelcoModelsApiKeyAuth {
    return MelcoModelsApiKeyAuthFromJSONTyped(json, false);
}

export function MelcoModelsApiKeyAuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsApiKeyAuth {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'api_key': json['api_key'],
        'device_info': MelcoModelsDeviceFromJSON(json['device_info']),
    };
}

export function MelcoModelsApiKeyAuthToJSON(value?: MelcoModelsApiKeyAuth | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'api_key': value.api_key,
        'device_info': MelcoModelsDeviceToJSON(value.device_info),
    };
}


